import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 100 90'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M75,48 L75,51.9375 C75,52.7541708 74.6937531,53.4687469 74.08125,54.08125 C73.4687469,54.6937531 72.7541708,55 71.9375,55 L64.0625,55 C63.2458292,55 62.5312531,54.6937531 61.91875,54.08125 C61.3062469,53.4687469 61,52.7541708 61,51.9375 L61,48 L75,48 Z M50,44 C45.0011597,44 39,43.9994507 39,46 L25,46 C25,43.103627 25.4975732,35.1452788 50,35 C74.5024268,34.9579024 75,43.103627 75,46 L61,46 C61,44.0025635 54.9988403,44 50,44 Z M39,48 L39,51.9375 C39,52.7541708 38.6937531,53.4687469 38.08125,54.08125 C37.4687469,54.6937531 36.7541708,55 35.9375,55 L28.0625,55 C27.2458292,55 26.5312531,54.6937531 25.91875,54.08125 C25.3062469,53.4687469 25,52.7541708 25,51.9375 L25,48 L39,48 Z'
    />
  </svg>
)

export default SVG